export enum ReqEnum {
  INIT = 'REQUEST::INIT',
  PENDING = 'REQUEST::PENDING',
  ERROR = 'REQUEST::ERROR',
  SUCCESS = 'REQUEST::SUCCESS',
}
export const REQ = {
  INIT: 'REQUEST::INIT',
  PENDING: 'REQUEST::PENDING',
  ERROR: 'REQUEST::ERROR',
  SUCCESS: 'REQUEST::SUCCESS',
};

export default REQ;
